import styled from '@emotion/styled';

export const TablesSection = styled.div`
  border-top: 1px solid var(--colorBlueGray1100);
  padding: 12px 2px;
  display: flex;
  flex-flow: row wrap;

  &:first-of-type {
    border-top: none;
  }

  &:last-of-type {
    padding-bottom: 100px;
  }
`;

export const TablesSectionTitle = styled.div`
  color: var(--colorWhite);
  margin: 0 10px 6px;
  font-weight: bold;
  flex: 1 1 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
`;
